
$(() => {
  $('.purchase-details .product-plus').on('click',function(e){
    e.preventDefault();
    let inpVal = +$('.purchase-details #quantity').val();
    let inpValMax = +$('.purchase-details #quantity').attr('max');
    setTimeout(()=>{
      if(inpVal != inpValMax){
        $('#quantity').val(inpVal + 1);
        console.log( $('.purchase-details .quantity').val());
      }else{
        $('#quantity').val(inpVal);
      }
 
    },0);
   
  });


  $('.purchase-details .product-minus').on('click',function(e){
    e.preventDefault
    let inpVal = +$('.purchase-details #quantity').val();
    if(inpVal > 1){
       setTimeout(()=>{
        $('#quantity').val(inpVal - 1);
        console.log( $('.purchase-details .quantity').val());
      },0);
    }
   
   
  });
});